import { render, staticRenderFns } from "./weeks.vue?vue&type=template&id=1d722f64&scoped=true"
import script from "./weeks.vue?vue&type=script&lang=js"
export * from "./weeks.vue?vue&type=script&lang=js"
import style0 from "./weeks.vue?vue&type=style&index=0&id=1d722f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d722f64",
  null
  
)

export default component.exports